module.exports = __webpack_public_path__ + "img/CAT_Estranho.0b1a990a.svg";